import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { PublishFileRecordCallable } from "@/action-dialog/callables/PublishFileRecordCallable";
import type { FileRecord } from "@cohesive/api-client";

export interface PublishFileRecordParams {
  record: FileRecord;
}

export function runPublishFileRecordWorkflow(
  params: PublishFileRecordParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    PublishFileRecordCallable.call({ record: params.record }),
  );
}
